var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-header px-4 pt-4 py-1 text-xs font-semibold uppercase"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }